import {BaseContainerModel} from '../../../base-container.model';
import {bl_del_driver_region_link_RowClass} from '../../../../dbschema';

export class DriverRegionLinkContainerModel extends BaseContainerModel {
  bl_del_driver_region_link: bl_del_driver_region_link_RowClass = new bl_del_driver_region_link_RowClass();
}
